import NxtWatchContext from '../../NxtWatchContext/NxtWatchContext'

import {
  Duration,
  ViewsCnt,
  ViewsAndDurationContainer,
  ChannelName,
  VideoTitle,
  AboutVideoContainer,
  ChannelImg,
  ChannelImgAndAboutVideoContainer,
  ThumbnailImg,
  HomeVideoItem,
  LinkEl,
} from './styledComponents'

const HomePageVideoItem = props => {
  const {details} = props
  const {
    id,
    title,
    thumbnailUrl,
    channel,
    viewCount,
    publishedDuration,
  } = details
  return (
    <NxtWatchContext.Consumer>
      {value => {
        const {darkMode} = value
        return (
          <LinkEl to={`videos/${id}`}>
            <HomeVideoItem>
              <ThumbnailImg src={thumbnailUrl} alt="video thumbnail" />
              <ChannelImgAndAboutVideoContainer>
                <ChannelImg src={channel.profileImgUrl} alt="channel logo" />
                <AboutVideoContainer>
                  <VideoTitle darkMode={darkMode}>{title}</VideoTitle>
                  <ChannelName>{channel.name}</ChannelName>
                  <ViewsAndDurationContainer>
                    <ViewsCnt>{viewCount} views</ViewsCnt>
                    <Duration> {publishedDuration} ago</Duration>
                  </ViewsAndDurationContainer>
                </AboutVideoContainer>
              </ChannelImgAndAboutVideoContainer>
            </HomeVideoItem>
          </LinkEl>
        )
      }}
    </NxtWatchContext.Consumer>
  )
}
export default HomePageVideoItem
